module.exports = __webpack_public_path__ + "static/vegas13-6-c77960ad5c41a76e58059fd70d914966.jpg";